import React, {useEffect, useState} from "react";
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "react-bootstrap/Button";
import {toast} from "react-toastify";
import {connectionErrorMessage, manualPaymentUpdateUrl} from "../../data";
import {useCookies} from "react-cookie";
import NumberFormat from "react-number-format";

function ManualPaymentUpdateDialog({openDialog, handleCloseDialog, getHistoryData, selectedTenant, currentAmount}) {
    const todayStr = new Date().toISOString().split("T")[0];

    const [cookies] = useCookies(['subscriptionToken']);
    const [lastModifiedDate, setLastModifiedDate] = useState(todayStr);
    const [paymentAmount, setPaymentAmount] = useState("0");
    const [previousAmount, setPreviousAmount] = useState(null);
    const [userInput, setUserInput] = useState("");

    useEffect(() => {
        if (currentAmount !== previousAmount) {
            setPaymentAmount(currentAmount);
            setPreviousAmount(currentAmount);
        }
    }, [currentAmount, previousAmount]);

    const handleCloseDialogWithClear = () => {
        setPreviousAmount(null);
        handleClear();
        handleCloseDialog();
    };

    const handleClear = () => {
        setPreviousAmount(null);
        setLastModifiedDate(todayStr);
        setPaymentAmount("0");
        setUserInput("");
    };

    const manualPaymentUpdate = () => {
        let request = ({
            ownerTenantId: selectedTenant?.ownerTenantId,
            lastModifiedDate: lastModifiedDate,
            paymentAmount: parseTurkishDecimal(paymentAmount),
            paymentRemark: userInput
        });

        fetch(manualPaymentUpdateUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify(request)
        }).then(res => {
            if (res.ok) {
                toast.success("Manuel Ödeme Güncelleme İşlemi Başarılı.", {
                    position: toast.POSITION.TOP_CENTER
                });
                getHistoryData();
            } else {
                toast.error("Manuel Ödeme Güncelleme İşlemi Başarısız. " + connectionErrorMessage, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        });

        handleCloseDialogWithClear();
    };

    const rows = [
        {
            label: "Son Güncelleme Tarihi",
            value: lastModifiedDate,
            onChange: (e) => setLastModifiedDate(e.target.value),
            type: "date"
        },
        {
            label: "Ödeme Ücret",
            value: paymentAmount,
            onChange: (e) => {
                if (e.target.value === "" || e.target.value === " ") {
                    setPaymentAmount("0");
                } else {
                    setPaymentAmount(e.target.value);
                }
            },
            type: "money"
        },
        {
            label: "Açıklama",
            value: userInput,
            onChange: (e) => setUserInput(e.target.value),
            type: "text"
        },
    ];

    function parseTurkishDecimal(input) {
        if (!input) return 0;
        const normalized = input.replace(/\./g, "").replace(",", ".");
        const number = parseFloat(normalized);
        return isNaN(number) ? 0 : number;
    }

    return (
        <Dialog
            open={openDialog}
            onClose={handleCloseDialogWithClear}
            maxWidth="xs"
            PaperProps={{
                style: {
                    border: "1px solid #a4a4ff",
                    borderRadius: 10,
                },
            }}
        >
            <DialogTitle
                sx={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    padding: "8px 12px",
                    color: "#0000ee",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                Manuel Ödeme Güncelleme
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialogWithClear}
                    sx={{color: "#888"}}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{padding: "8px 10px 0 12px"}}>
                <p>{selectedTenant?.tenantName}</p>
                <Table size="small" sx={{mt: 1}}>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    backgroundColor: index % 2 === 0 ? "#f1f1f1" : "#ffffff",
                                }}
                            >
                                <TableCell
                                    sx={{
                                        fontWeight: "bold",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        width: "50%",
                                        padding: "8px",
                                    }}
                                >
                                    {row.label}
                                </TableCell>
                                <TableCell sx={{padding: "8px"}}>
                                    <Box sx={{position: "relative"}}>
                                        {row.type === "money" ? (
                                            <NumberFormat
                                                customInput={TextField}
                                                fullWidth
                                                size="small"
                                                value={row.value.toString()}
                                                thousandSeparator="."
                                                decimalSeparator=","
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                onChange={row.onChange}
                                                // onValueChange={({ value }) => { row.onChange(value)}}
                                                InputProps={{
                                                    endAdornment: (
                                                        <span style={{
                                                            marginLeft: 1,
                                                            fontSize: "13px",
                                                            color: "#757575",
                                                            whiteSpace: "nowrap"
                                                        }}>TL</span>
                                                    ),
                                                    style: {
                                                        textAlign: "right",
                                                        fontSize: "13px"
                                                    },
                                                }}
                                                disabled={row.disabled}
                                                sx={{
                                                    backgroundColor: row.disabled ? "#d3d3d3" : "#ffffff",
                                                    "& .MuiInputBase-input": {
                                                        color: row.disabled ? "#9e9e9e" : "inherit",
                                                    },
                                                    "& .MuiOutlinedInput-root": {
                                                        "& fieldset": {
                                                            padding: "0px 80px",
                                                        },
                                                        borderColor: row.disabled ? "#bdbdbd" : "#1e88e5",
                                                    },
                                                    '&:hover .MuiOutlinedInput-root': {
                                                        borderColor: row.disabled ? "#bdbdbd" : "#1565c0",
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-root': {
                                                        borderColor: row.disabled ? "#bdbdbd" : "#1565c0",
                                                    },
                                                }}
                                            />) : (
                                            <TextField
                                                type={row.type}
                                                fullWidth
                                                size="small"
                                                value={row.value}
                                                onChange={row.onChange}
                                                disabled={row.disabled}
                                                inputProps={{
                                                    style: {textAlign: "right", fontSize: "13px"},
                                                    ...row.inputProps,
                                                }}
                                                sx={{
                                                    backgroundColor: row.disabled ? "#d3d3d3" : "#ffffff",
                                                    "& .MuiInputBase-input": {
                                                        color: row.disabled ? "#9e9e9e" : "inherit",
                                                    },
                                                    "& .MuiOutlinedInput-root": {
                                                        "& fieldset": {
                                                            padding: "0px 80px",
                                                        },
                                                        borderColor: row.disabled ? "#bdbdbd" : "#1e88e5",
                                                    },
                                                    '&:hover .MuiOutlinedInput-root': {
                                                        borderColor: row.disabled ? "#bdbdbd" : "#1565c0",
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-root': {
                                                        borderColor: row.disabled ? "#bdbdbd" : "#1565c0",
                                                    },
                                                }}
                                            />
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>

            <DialogActions
                sx={{
                    padding: "10px 12px",
                    justifyContent: "flex-end",
                }}
            >
                <Box sx={{display: 'flex', gap: '5px'}}>
                    <Button variant="secondary" onClick={handleClear}>
                        Temizle
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => manualPaymentUpdate()}
                    >
                        Kaydet
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export default ManualPaymentUpdateDialog;